export default __webpack_public_path__ + "static/app1-b3d9b7e6eb0d99a8aa4cdfbc4d32f02f.jpg";